// About.js
import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Shipment from "../../components/Shipment/Shipment";
import Container from "../../assets/Container.jpg";
import Handshake from "../../assets/handshake.jpg";
import "./About.css";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";

const About = () => {
  return (
    <>
      <Navbar />

      {/* === WHO WE ARE SECTION === */}
      <div className="about-container">
        <div className="about-text-block">
          <h2 className="about-title">Who We Are?</h2>
          <p>
            <strong>NewBell International Co. Ltd.</strong>, is a{" "}
            <strong>second-generation family-owned export business</strong>{" "}
            located in <strong>Bangkok, Thailand</strong> with our branch in{" "}
            <strong>Yiwu, China</strong>.
          </p>
          <p>
            Our company was established in the year <strong>2000</strong>, by
            its founders who have{" "}
            <strong>
              experience in this trade for more than three decades
            </strong>
            .
          </p>
          <p>
            We strongly believe in the concept of{" "}
            <strong>Vasudhaiva Kutumbakam</strong>, a Sanskrit phrase which
            means <em>"The World Is One Family."</em>
          </p>
        </div>
        <div className="about-image-block">
          <img src={Container} alt="Container" className="about-image" />
        </div>
      </div>

      {/* === WHY CHOOSE US SECTION === */}
      <div className="about-container">
        <div className="about-image-block">
          <img src={Handshake} alt="Handshake" className="about-image" />
        </div>
        <div className="about-text-block">
          <h2 className="about-title">Why Choose Us?</h2>
          <p>
            We connect people and businesses by{" "}
            <strong>
              exporting products from Asia to the rest of the world
            </strong>
            . From sourcing the best products, ensuring quality, and smoothly
            shipping the products to our buyers gives us ultimate satisfaction
            and strengthens our association for{" "}
            <strong>long-term mutual success</strong>.
          </p>
          <p>
            From <strong>21 years of our establishment</strong>, we cater to
            different customers having different types of businesses. This has
            truly enhanced our experience and capability to offer a{" "}
            <strong>big range of products and services</strong>.
          </p>
          <p>
            Each of us has a <strong>unique trait</strong> adding values to the
            rest of the team, and this ensures us to serve you to the best of
            our ability with a{" "}
            <strong>positive, honest and creative mindset</strong>.
          </p>
        </div>
      </div>

      {/* === SHIPMENT AND FOOTER === */}
      <Shipment />
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default About;
